module.exports = __webpack_public_path__ + "static/media/edit--light.fd5dbfff.svg";